import { connect } from 'react-redux';

import { deleteEvent } from '../../../redux/calendar';
import { toggleDeleteModal } from '../../../redux/modals';
import DeleteEventModal from './DeleteEventModal';

const mapStateToProps = (state) => state.modals.deleteModal;

const mapDispatchToProps = {
  onConfirm: () => deleteEvent(),
  onHide: () => toggleDeleteModal()
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteEventModal);
